module.exports = __webpack_public_path__ + "static/img/bigWheel3.bfc8169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigWheel3.png
// module id = i4k9
// module chunks = 2